/** Round to nearest whole KES. */
export const roundKes = (n) => Math.round(n);
export const sumLines = (items) => items.reduce((a, b) => a + b.amountKes, 0);
export function buildQuote(opts) {
    const subtotal = sumLines(opts.items);
    const total = subtotal + opts.leviesKes + opts.stampDutyKes;
    return {
        product: opts.product,
        ratesVersion: opts.ratesVersion,
        currency: "KES",
        items: opts.items,
        subtotalKes: roundKes(subtotal),
        leviesKes: roundKes(opts.leviesKes),
        stampDutyKes: roundKes(opts.stampDutyKes),
        totalKes: roundKes(total),
    };
}
